import { Injectable } from '@angular/core';
import { Observable, Subject, filter } from 'rxjs';

export enum AppEventType {
  DataRefresh = 'data-refresh',
}

export interface AppEvent {
  type: AppEventType;
}

@Injectable({ providedIn: 'root' })
export class AppEventBusService {
  private readonly events$ = new Subject<AppEvent>();

  emit(type: AppEventType): void {
    this.events$.next({ type });
  }

  on(type: AppEventType): Observable<AppEvent> {
    return this.events$.pipe(filter((e) => e.type === type));
  }
}
